import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import ProbelyMappingForm from './ProbelyMappingForm';

function ProbelyCredentialsForm(props, ref) {
    const fields = useMemo(() => (
        [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        },
        {
            name: "authToken",
            label: "Auth Token",
            required: true,
            type: FieldTypes.PASSWORD,
            help: 'Add the Auth Token which is valid for the next 24 hours at-least.'
        }]
    ),[])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={ProbelyMappingForm}
            initialValue={{ apiEndpoint: 'https://api.probely.com' }}
        />
    )
}

export default forwardRef(ProbelyCredentialsForm);